// extracted by mini-css-extract-plugin
export default {"section":"BurgerIngredients_section__g7jA7","a":"BurgerIngredients_a__7rIME","nav":"BurgerIngredients_nav__d5PQV"};